
export enum TradingRestrictionFilterType {
    AllSchemesAndInstruments = 0,
    Instrument = 1,
    IncentiveScheme = 2,
}